// ref code: https://cleverbeagle.com/blog/articles/tutorial-how-to-load-third-party-scripts-dynamically-in-javascript
/*
  This script is to load scripts async
  example:
    import scriptLoader from ('this file's relative loacation');

    const scripts = [
      {
        id: 'scriptId',
        url: 'url to script',
        callback: () => { //callback on successfully loaded },
      },
      {
        ...for another script
      },
    ];

    scriptLoader(scripts)
      .then(([resultFromCallback1, resultFromCallback2, ...]) => { doSomethingWhenAllLoaded()});
      .catch((error) => { console.log(error.message); });
*/
const initiateLoadDynamicScripts = () => {
    const currentLoadedScript = {};
    const loadDynamicScript = (id, url, attr = {}) => (new Promise((resolve, reject) => {
        var _a;
        const existingScript = document.getElementById(id);
        const addScriptElement = () => {
            const script = document.createElement('script');
            script.src = url;
            script.id = id;
            Object.keys(attr).forEach((attrName) => {
                script.setAttribute(attrName, attr[attrName]);
            });
            document.body.appendChild(script);
            script.onload = () => {
                currentLoadedScript[id] = url;
                return resolve();
            };
            script.onerror = () => reject(new Error(`Error loading ${url}`));
        };
        if (!existingScript) {
            return addScriptElement();
        }
        if (existingScript) {
            if (currentLoadedScript[id]) {
                return resolve();
            }
            (_a = existingScript.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(existingScript);
            return addScriptElement();
        }
        return null;
    }));
    const callbackOnLoaded = ({ id = '', url = '', callback = () => { }, attr = {}, }) => (loadDynamicScript(id, url, attr)
        .then(callback));
    return (scripts) => (Promise.all(scripts.map(callbackOnLoaded)));
};
export default initiateLoadDynamicScripts();
